import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createSlots as _createSlots, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("同意")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("拒绝")
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("提交审批")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消")

import { ref, reactive, unref, onMounted, nextTick } from 'vue';
import { ElMessage, ElForm, FormRules } from 'element-plus';
import { useRoute } from 'vue-router'

/* apis */
import { GetContractApi, CtSubmitApi, CtAgreeApi, CtRejectApi } from '@/apis/contract/contract.api'

/* 组件 */
import ContractWriter from '../components/0_ContractWriter.vue'

/* 类型文件 */
import { ContractDetail, CtAuditDto } from '@/apis/contract/contract.type'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { query } = useRoute()

const loading = ref(false)
const actions = ref<string>('')
const showDialog = ref<boolean>(false)

/*  
    为什么会有这个控制变量呢？那是因为提交审核之后，OA回调信息不及时，无法修改审批记录的处理状态 
    所以只能委屈一下了
*/
const isApprove = ref<boolean>(false)
const disabledBtn = ref<boolean>(false)

const rmkFormRef = ref<ComponentRef<typeof ElForm>>()

const currentRow = ref<Nullable<ContractDetail>>(null)
const writerRef = ref<ComponentRef<typeof ContractWriter>>()

const auditSchema = reactive<CtAuditDto>({
    id: '',
    revision: '',
    remark: ''
})

const formRules = reactive<FormRules>({
    remark: [
        { required: true, message: '审核批示不能为空', trigger: 'blur' },
    ],
})

const finishAction = () => {

    loading.value = false
    showDialog.value = false

}

/* 审核（通过/不通过） */
const onAuditBtnClick = (action: string) => {
    actions.value = action
    showDialog.value = true
};

/* 审批保存按钮 */
const onSaveBtnClick = () => {

    unref(rmkFormRef)?.validate((isVali) => {

        if (!isVali) return;
        loading.value = true;

        const auditData = unref(auditSchema);

        const ApiFunc = unref(actions) == "agree" ? CtAgreeApi : CtRejectApi

        ApiFunc(auditData).then((res) => {

            if (!res.succeeded) {

                ElMessage.error(res.errors)

            }
            else {

                disabledBtn.value = true

                ElMessage.success("审核成功")

            }

        }).finally(finishAction)

    })
};

/* 检查是否可以显示审批按钮 */
const checkAuditOptions = (res: any) => {

    const { approve, data } = res

    isApprove.value = approve

    unref(auditSchema).id = data.id
    unref(auditSchema).revision = data.revision

}

onMounted(() => {

    const writer = unref(writerRef);

    writer?.methods.setFormDataByWorkId(query.workId as string)

})


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(ContractWriter, {
      ref_key: "writerRef",
      ref: writerRef,
      "is-preview": true,
      showprogress: true,
      titles: `合同审批`,
      onCheckAudit: checkAuditOptions
    }, _createSlots({ _: 2 }, [
      (isApprove.value)
        ? {
            name: "Options",
            fn: _withCtx(() => [
              (!disabledBtn.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      style: {"width":"120px"},
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (onAuditBtnClick('agree')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "danger",
                      style: {"width":"120px"},
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (onAuditBtnClick('reject')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          }
        : undefined
    ]), 1024)), [
      [_directive_loading, loading.value]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showDialog).value = $event)),
      title: "审批批示",
      width: "30%",
      "lock-scroll": false,
      center: ""
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_unref(ElForm), {
          ref_key: "rmkFormRef",
          ref: rmkFormRef,
          "label-position": "top",
          model: _unref(auditSchema),
          rules: _unref(formRules)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { prop: "remark" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(auditSchema).remark,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(auditSchema).remark) = $event)),
                  type: "textarea",
                  "show-word-limit": "",
                  rows: "6",
                  maxlength: "150",
                  placeholder: "请输入审核批示"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])), [
          [_directive_loading, loading.value]
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: onSaveBtnClick,
            disabled: loading.value
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (showDialog.value = false)),
            disabled: loading.value
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})